// Utilities
import { dispatch, make } from 'vuex-pathify'

// Globals
// import { IN_BROWSER } from '@/util/globals'
import axios from 'axios'
import store from '@/store'

const state = {
  users: null,
  options: {},
  search: '',
  selected_roles: [],
  selected_membership: null,
  dark: false,
  drawer: {
    image: 0,
    gradient: 0,
    mini: false,
  },
  gradients: [
    'rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)',
    'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)',
    'rgba(244, 67, 54, .8), rgba(244, 67, 54, .8)',
  ],
  images: [
    'sidebar-1.webp',
    'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-1.jpg',
    'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-2.jpg',
    'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-3.jpg',
    'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-4.jpg',
  ],
  notifications: [],
  rtl: false,
}

const mutations = {
  ...make.mutations(state),
}

const actions = {
  /*
  fetch: ({ commit }) => {
    const local = localStorage.getItem('vuetify@user') || '{}'
    const user = JSON.parse(local)

    for (const key in user) {
      commit(key, user[key])
    }

    if (user.dark === undefined) {
      commit('dark', window.matchMedia('(prefers-color-scheme: dark)'))
    }
  },
  update: ({ state }) => {
    if (!IN_BROWSER) return

    localStorage.setItem('vuetify@user', JSON.stringify(state))
  },
  */
  search (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/user/search', payload)
        .then(result => {
          state.users = result.data
          resolve(result.data)
        }).catch(error => {
        reject(error)
      })
    })
  },
  searchAddressBook (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/user/search-address-book', payload)
        .then(result => {
          state.users = result.data
          resolve(result.data)
        }).catch(error => {
        reject(error)
      })
    })
  },
  search_dev (context, payload) {
    // alert(this.$t('dashboard'))
    return new Promise((resolve, reject) => {
      axios.post('/api/user/search_dev', payload)
        .then(result => {
          state.users = result.data
          resolve(result.data)
        }).catch(error => {
        reject(error)
      })
    })
  },
  fetch (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/user/' + payload.id).then(result => {
        resolve(result.data)
      }).catch(error => {
        if (error.response.status === 401) {
          mutations.logout()
        }
        reject(error)
      })
    })
  },
  documents (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/user/' + payload.id + '/documents').then(result => {
        resolve(result.data)
      }).catch(error => {
        if (error.response.status === 401) {
          mutations.logout()
        }
        reject(error)
      })
    })
  },
  update (context, payload) {
    return new Promise((resolve, reject) => {
      axios.patch('/api/user', payload)
        .then(result => {
          state.user = result.data
          resolve(result.data)
          dispatch('datasource/clear')
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  insert (context, payload) {
    return new Promise((resolve, reject) => {
      axios.put('/api/user', payload)
        .then(result => {
          resolve(result.data)
          dispatch('datasource/clear')
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  registration (context, payload) {
    return new Promise((resolve, reject) => {
      // alert(this.$store.app.locale)
      payload.language = store.get('app/locale')
      // console.log('------>' + payload.language)
      axios.put('/api/user/register', payload)
        .then(result => {
          resolve(result.data)
          dispatch('datasource/clear')
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  delete (context, payload) {
    return new Promise((resolve, reject) => {
      axios.delete('/api/user/' + payload.id, payload)
        .then(result => {
          resolve(result.data)
          dispatch('datasource/clear')
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  detachOrganization (context, payload) {
    return new Promise((resolve, reject) => {
      axios.delete('/api/user/organization/' + payload.id, payload)
        .then(result => {
          resolve(result.data)
          dispatch('datasource/clear')
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  updateMembership (context, payload) {
    return new Promise((resolve, reject) => {
      axios.patch('/api/user/membership', payload)
        .then(result => {
          resolve(result.data)
          dispatch('datasource/clear')
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  updatePermit (context, payload) {
    return new Promise((resolve, reject) => {
      axios.patch('/api/user/permit', payload)
        .then(result => {
          resolve(result.data)
          dispatch('datasource/clear')
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  fetchPilotInfo (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/user/' + payload.id + '/pilot-info').then(result => {
        resolve(result.data)
      }).catch(error => {
        if (error.response.status === 401) {
          mutations.logout()
        }
        reject(error)
      })
    })
  },
  fetchBalances (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/user/' + payload.id + '/balances').then(result => {
        resolve(result.data)
        // dispatch('datasource/clear')
      }).catch(error => {
        if (error.response.status === 401) {
          mutations.logout()
        }
        reject(error)
      })
    })
  },
  fetchProficiency (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/user/' + payload.id + '/proficiency').then(result => {
        resolve(result.data)
        // dispatch('datasource/clear')
      }).catch(error => {
        if (error.response.status === 401) {
          mutations.logout()
        }
        reject(error)
      })
    })
  },
  updatePilotInfo (context, payload) {
    return new Promise((resolve, reject) => {
      axios.patch('/api/user/pilot-info', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
}

const getters = {
  dark: (state, getters) => {
    return (
      state.dark ||
      getters.gradient.indexOf('255, 255, 255') === -1
    )
  },
  gradient: state => {
    return state.gradients[state.drawer.gradient]
  },
  image: state => {
    return state.drawer.image === '' ? state.drawer.image : state.images[state.drawer.image]
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
